import { isTrappedByDTEEquipment } from '@dte/otw-azure-functions/src/common/reports/customerReport/symptomsToCallCodeV3/matchesSymptomsV3';
import { atom, useAtomValue } from 'jotai';
import { answersAtom } from '../../../_atoms/draftReport/stepData';

const trappedByDTEEquipmentAtom = atom((get) => {
	const answers = get(answersAtom);
	return isTrappedByDTEEquipment(answers);
});

export function useIsPublicTrapped(): boolean | undefined {
	return useAtomValue(trappedByDTEEquipmentAtom);
}
